// extracted by mini-css-extract-plugin
export default {"checkboxIcon":"hoverIcon_checkboxIcon__PFYAo","downtrendIcon":"hoverIcon_downtrendIcon__qLLoC"};